import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { useUI } from 'Editor'
import React, { useEffect } from 'react'
import { useTabQuery } from 'hooks/useQueryState'
import InfoPanel from './Info'
import Layers from './Layers'
import Tonings from './Tonings'
import DefaultSetPanel from './default-set'
import DLCs from './dlcs'
import Sticker from './Sticker'

const datas = [
  { name: 'Info', to: 'info' },
  { name: 'Layers', to: 'layers' },
  { name: 'Tonings', to: 'tonings' },
  { name: 'DLCs', to: 'dlcs' },
  { name: 'Sets', to: 'defaultSet' },
  { name: 'Sticker', to: 'sticker' },
]

const EDITOR_TABS = datas.map((item) => item.to)

const RightPanel = () => {
  const toggleTab = useUI((state) => state.toggleTab)
  const [tabQuery, setTabQuery] = useTabQuery('tab', 'info')
  const currTab = EDITOR_TABS.includes(tabQuery) ? tabQuery : 'info'

  useEffect(() => {
    toggleTab(currTab)
  }, [currTab, toggleTab])

  return (
    <div className="flex h-full min-h-0 flex-col gap-2">
      <Tabs
        value={currTab}
        onValueChange={(tab) => {
          setTabQuery(tab)
          toggleTab(tab)
        }}
        className="shrink-0"
      >
        <TabsList className="h-auto flex-wrap justify-start gap-1 lg:gap-2">
          {datas.map((data) => (
            <TabsTrigger key={data.to} value={data.to}>
              {data.name}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>

      <div className="min-h-0 flex-1 overflow-hidden">
        {currTab === 'info' && <InfoPanel />}
        {currTab === 'layers' && <Layers />}
        {currTab === 'tonings' && <Tonings />}
        {currTab === 'dlcs' && <DLCs />}
        {currTab === 'defaultSet' && (
          <div className="h-full overflow-y-auto">
            <DefaultSetPanel />
          </div>
        )}
        {currTab === 'sticker' && (
          <div className="h-full min-h-0 overflow-hidden">
            <Sticker />
          </div>
        )}
      </div>
    </div>
  )
}

export default RightPanel
